<template>
  <div>
    <Head title="Dashboard" />
    <h1 class="mb-8 text-3xl font-bold">Bienvenido al sistema de <span class="text-sky-500">preventa</span>, el día de hoy es: {{ formattedDate }}</h1>    
  </div>
  <div class="flex items-center justify-between gap-4 border border-gray-200 bg-white py-6 px-7 mb-4 shadow-md dark:border-gray-700 dark:bg-gray-800">
    <p class="text-lg"> Las <span class="font-semibold">ventas totales</span> de día de hoy son las siguientes:</p>
    <div class=" flex items-center">
      <text-input v-model="form.date_start" type="date" id="date_start" :max="maxDate" class="mr-2" />
      <button @click="filterByDate(form.date_start)" class="text-white bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Cambiar</button>
    </div>
    <!--<tooltip
      text="La fecha por defecto es la actual, se mostrara informacion de la fecha actual, un dia antes de y sus pares una semana atrás">
      <button class="p-2 text-white bg-blue-600 rounded-full flex items-center">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M13 16h-1v-4h-1m0-4h.01M12 2a10 10 0 100 20 10 10 0 000-20z" />
        </svg>
      </button>
    </tooltip> -->
  </div>
  <div class="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6 xl:grid-cols-4 2xl:gap-7">
    <!-- Card Item Start -->    
    <CardItem v-for="(item, index) in cardItems" :key="index" :icon="item.icon" :title="item.title"
      :subtitle="item.subtitle" :total="item.total" :boxes="item.boxes" :bags="item.bags" :date="item.date"
      @click-details="handleClickDetails(item.date)" />
  </div>  
  <!-- Card Item End -->
  <!-- Charts -->
  <div class="mt-4 grid grid-cols-12 gap-4 md:mt-6 md:gap-6 2xl:mt-7 2xl:gap-7">
    <!-- Chart one -->
    <!--<div
      class="col-span-12 rounded-sm border border-stroke bg-white px-5 pt-7 pb-5 shadow-default dark:border-strokedark dark:bg-boxdark sm:px-7 xl:col-span-8">
      <div class="flex flex-wrap items-start justify-between gap-3 sm:flex-nowrap">
        <div class="flex w-full flex-wrap gap-3 sm:gap-5">
          <div class="flex min-w-44">
            <div class="w-full">
              <h4 class="text-xl font-bold text-black dark:text-white">Ventas por preventista </h4>
            </div>
          </div>
        </div>
        <div class="flex w-full max-w-45 justify-end">
          <div class="inline-flex items-center rounded-md bg-neutral-100 p-1 dark:bg-meta-4">
            <button
              class="rounded bg-white py-1 px-3 text-xs font-medium text-black hover:bg-white hover:shadow-card dark:text-white dark:hover:bg-boxdark">
              Mes
            </button>
          </div>
        </div>
      </div>
      <div>
        <VueApexCharts type="area" height="350" :options="chartOptions" :series="series"></VueApexCharts>
      </div>
    </div> -->
    <!-- chart one end -->
    <!-- Chart two -->
    <!--<div
      class="col-span-12 rounded-sm border border-stroke bg-white p-7 shadow-default dark:border-strokedark dark:bg-boxdark xl:col-span-4">
      <div class="mb-4 justify-between gap-4 sm:flex">
        <div>
          <h4 class="text-xl font-bold text-black dark:text-white">Ventas totales por semana </h4>
        </div>
      </div>
      <div>
        <VueApexCharts type="bar" height="335" :options="chartOptionsTwo" :series="seriesTwo"></VueApexCharts>
      </div>
    </div> -->
    <!-- chart two end -->
  </div>
  <!-- Charts end -->
  <!-- visits -->
   <div id="route-list">
  <div class="bg-white my-4 p-4 shadow overflow-x-auto" v-if="userRouteJourneys.length != 0">
    <div class="flex justify-between items-center p-4">
      <h4 class="text-xl font-bold text-black dark:text-white">Rutas de visitas </h4>    
      <div class=" flex items-center">
        <text-input v-model="form.date_route" type="date" id="date_start_route" :max="maxDate" class="mr-2" />
        <button @click="filterByDateRoute(form.date_route)" class="text-white bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Cambiar</button>
      </div>
    </div>
    <table class="w-full table-auto">
      <thead class="bg-gray-200">
        <tr>
          <th class="px-4 py-3 text-left text-gray-700 font-bold">Fecha de Inicio</th>
          <th class="px-4 py-3 text-left text-gray-700 font-bold">Fecha fin</th>
          <th class="px-4 py-3 text-left text-gray-700 font-bold">Ruta</th>
          <th class="px-4 py-3 text-left text-gray-700 font-bold">Día Ruta</th>
          <th class="px-4 py-3 text-left text-gray-700 font-bold">Encargado ruta</th>
          <th class="px-4 py-3 text-left text-gray-700 font-bold">Status</th>
          <th class="px-4 py-3 text-gray-700 font-bold"></th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-200">
        <tr v-for="journey in userRouteJourneys" :key="userRouteJourneys.id">
          <td class="px-4 py-3 text-gray-700">{{ formatDate(journey.start_date) }}</td>
          <td class="px-4 py-3 text-gray-700">{{ journey.end_date == null? '': formatDate(journey.end_date) }}</td>
          <td class="px-4 py-3 text-gray-700">{{ journey.route }}</td>
          <td class="px-4 py-3 text-gray-700">{{ journey.day }}</td>
          <td class="px-4 py-3 text-gray-700">{{ journey.user_name }}</td>
          <td class="px-4 py-3 text-gray-700">
            <span :class="{
      'bg-green-500 text-white': journey.status === 1,
      'bg-gray-500 text-white': journey.status === 0, 'bg-yellow-500 text-white': journey.status === 2
    }" class="px-2 py-1 rounded-full text-sm font-medium">{{ journey.status === 0 ? 'Finalizada' : journey.status === 2
      ? 'Incompleta' : 'Activa'
              }}</span>
          </td>
          <td class="px-4 py-3 text-right">
            <button class="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-md text-sm flex gap-1"
              @click="goToRouteJourney(journey.id)">
              Ver
              <img :src="getIconUrl('map.png')" class="w-6 h-6 object-contain" alt="rutas" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>    
    <!-- <pagination class="mt-6" :links="userRouteJourneys.links" /> -->
  </div>
  <div class="bg-white rounded-md shadow overflow-x-auto my-4 p-4" v-if="userRouteJourneys.length == 0">
    <div class="flex justify-between items-center p-4">
      <h4 class="text-xl font-bold text-black dark:text-white">Rutas de visitas </h4>    
      <div class=" flex items-center">
        <text-input v-model="form.date_route" type="date" id="date_start_route" :max="maxDate" class="mr-2" />
        <button @click="filterByDateRoute(form.date_route)" class="text-white bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Cambiar</button>
      </div>
    </div>
    <p>No hay rutas iniciadas asociadas a la fecha indicada</p>
  </div>
</div>
  <!-- end visits -->
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import VueApexCharts from 'vue3-apexcharts'
import Pagination from '@/Shared/Pagination'
import CardItem from '@/Components/InfoCard'
import TextInput from '@/Shared/TextInput'
import Tooltip from '@/Shared/Tooltip'

export default {
  components: {
    Head,
    Link,
    VueApexCharts,
    Pagination,
    CardItem,
    TextInput,
    Tooltip
  },
  layout: Layout,
  props: {
    totalSalesToday: Number,
    totalSalesYesterday: Number,
    totalSalesLastWeekSameDay: Number,
    totalSalesLastWeekPreviousDay: Number,
    totalAmountBoxesToday: Number,
    totalAmountBoxesYesterday: Number,
    totalAmountBoxesLastWeekSameDay: Number,
    totalAmountBoxesLastWeekPreviousDay: Number,
    totalAmountPiecesToday: Number,
    totalAmountPiecesYesterday: Number,
    totalAmountPiecesLastWeekSameDay: Number,
    totalAmountPiecesLastWeekPreviousDay: Number,
    currentDate: String,
    yesterdayDate: String,
    lastWeekSameDay: String,
    lastWeekPreviousDay: String,
    dataSeries: {
      type: Array,
      default: () => []
    },
    dataSeriesTwo: {
      type: Array,
      default: () => []
    },
    
    currentMonthName: String,
    userRouteJourneys: Array,
    filters: Object,
    dateStart: String,
    dateRoute: String,    
    //routesJourneyActive: Array,
    //totalRoutesJourney: Array
  },
  data() {
    const today = new Date();
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    const formattedDate = today.toLocaleDateString('es-ES', options);
    return { 
      form: {
        date_start:  this.dateStart,
        date_route:  this.dateRoute,        
      },
      formattedDate,
      cardItems: [
        {
          icon: `<svg 
            class="fill-indigo-700 dark:fill-white"
            xmlns="http://www.w3.org/2000/svg" 
            width="22" 
            height="22" 
            fill="none"
            viewBox="0 0 256 256"
          >
          <path fill="" d="M168 128a40 40 0 1 1-40-40a40 40 0 0 1 40 40m80-64v128a8 8 0 0 1-8 8H16a8 8 0 0 1-8-8V64a8 8 0 0 1 8-8h224a8 8 0 0 1 8 8m-16 46.35A56.78 56.78 0 0 1 193.65 72H62.35A56.78 56.78 0 0 1 24 110.35v35.3A56.78 56.78 0 0 1 62.35 184h131.3A56.78 56.78 0 0 1 232 145.65Z"/></svg>`,          
          subtitle: this.formatDateOnly(this.currentDate),
          boxes: this.totalAmountBoxesToday,
          bags: this.totalAmountPiecesToday,
          total: '$' + this.totalSalesToday.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          date: this.currentDate
        },
        {
          icon: `<svg 
            class="fill-indigo-700 dark:fill-white"
            xmlns="http://www.w3.org/2000/svg" 
            width="22" 
            height="22" 
            fill="none"
            viewBox="0 0 256 256"
          >
          <path fill="" d="M168 128a40 40 0 1 1-40-40a40 40 0 0 1 40 40m80-64v128a8 8 0 0 1-8 8H16a8 8 0 0 1-8-8V64a8 8 0 0 1 8-8h224a8 8 0 0 1 8 8m-16 46.35A56.78 56.78 0 0 1 193.65 72H62.35A56.78 56.78 0 0 1 24 110.35v35.3A56.78 56.78 0 0 1 62.35 184h131.3A56.78 56.78 0 0 1 232 145.65Z"/></svg>`,          
          subtitle: this.formatDateOnly(this.yesterdayDate),
          boxes: this.totalAmountBoxesYesterday,
          bags: this.totalAmountPiecesYesterday,
          total: '$' + this.totalSalesYesterday.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          date: this.yesterdayDate
        },
        {
          icon: `<svg 
            class="fill-indigo-700 dark:fill-white"
            xmlns="http://www.w3.org/2000/svg" 
            width="22" 
            height="22" 
            fill="none"
            viewBox="0 0 256 256"
          >
          <path fill="" d="M168 128a40 40 0 1 1-40-40a40 40 0 0 1 40 40m80-64v128a8 8 0 0 1-8 8H16a8 8 0 0 1-8-8V64a8 8 0 0 1 8-8h224a8 8 0 0 1 8 8m-16 46.35A56.78 56.78 0 0 1 193.65 72H62.35A56.78 56.78 0 0 1 24 110.35v35.3A56.78 56.78 0 0 1 62.35 184h131.3A56.78 56.78 0 0 1 232 145.65Z"/></svg>`,          
          subtitle: this.formatDateOnly(this.lastWeekSameDay),
          boxes: this.totalAmountBoxesLastWeekSameDay,
          bags: this.totalAmountPiecesLastWeekSameDay,
          total: '$' + this.totalSalesLastWeekSameDay.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          date: this.lastWeekSameDay
        },
        {
          icon: `<svg 
            class="fill-indigo-700 dark:fill-white"
            xmlns="http://www.w3.org/2000/svg" 
            width="22" 
            height="22" 
            fill="none"
            viewBox="0 0 256 256"
          >
          <path fill="" d="M168 128a40 40 0 1 1-40-40a40 40 0 0 1 40 40m80-64v128a8 8 0 0 1-8 8H16a8 8 0 0 1-8-8V64a8 8 0 0 1 8-8h224a8 8 0 0 1 8 8m-16 46.35A56.78 56.78 0 0 1 193.65 72H62.35A56.78 56.78 0 0 1 24 110.35v35.3A56.78 56.78 0 0 1 62.35 184h131.3A56.78 56.78 0 0 1 232 145.65Z"/></svg>`,          
          subtitle: this.formatDateOnly(this.lastWeekPreviousDay),
          boxes: this.totalAmountBoxesLastWeekPreviousDay,
          bags: this.totalAmountPiecesLastWeekPreviousDay,
          total: '$' + this.totalSalesLastWeekPreviousDay.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          date: this.lastWeekPreviousDay
        }
      ],
      chartOptions: {
        legend: {
          show: true,
          position: 'top',
          horizontalAlign: 'left'
        },

        chart: {
          id: "vuechart-example",
          height: 335,
          type: 'area',
          dropShadow: {
            enabled: true,
            color: '#623CEA14',
            top: 10,
            blur: 4,
            left: 0,
            opacity: 0.1
          },
          toolbar: {
            show: false
          }
        },
        responsive: [
          {
            breakpoint: 1024,
            options: {
              chart: {
                height: 300
              }
            }
          },
          {
            breakpoint: 1366,
            options: {
              chart: {
                height: 350
              }
            }
          }
        ],
        stroke: {
          width: [2, 2],
          curve: 'straight'
        },

        grid: {
          xaxis: {
            lines: {
              show: true
            }
          },
          yaxis: {
            lines: {
              show: true
            }
          }
        },
        dataLabels: {
          enabled: false
        },
        markers: {
          size: 3,
          strokeWidth: 3,
          strokeOpacity: 0.9,
          strokeDashArray: 0,
          fillOpacity: 1,
          discrete: [],
          hover: {
            size: undefined,
            sizeOffset: 4
          }
        },
        xaxis: {
          type: 'category',
          categories: Array.from({ length: 30 }, (_, i) => i + 1), // Genera los días del mes
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          title: {
            text: this.currentMonthName,
            style: {
              fontSize: '15px'
            }
          },
        },
        yaxis: {
          title: {
            text: 'Ventas ($)',
            style: {
              fontSize: '15px'
            }
          },
          min: 0,
          max: null
        }
      },
      series: [],
      chartOptionsTwo: {

        chart: {
          id: "vuechart",
          type: 'bar',
          height: 335,
          stacked: true,
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          }
        },
        responsive: [
          {
            breakpoint: 1536,
            options: {
              plotOptions: {
                bar: {
                  borderRadius: 0,
                  columnWidth: '25%'
                }
              }
            }
          }
        ],
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 0,
            columnWidth: '25%',
            borderRadiusApplication: 'end',
            borderRadiusWhenStacked: 'last'
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'category',
          categories: ['L', 'M', 'M', 'J', 'V', 'S', 'D'],
        },
      },
      legend: {
        position: 'top',
        horizontalAlign: 'left',
        fontWeight: 500,
        fontSize: '14px',

        markers: {
          radius: 99
        }
      },
      fill: {
        opacity: 1
      },
      seriesTwo: []
    }
  },
  mounted() {
    this.initializeChartData();
  },
  methods: {
    goToRouteJourney(id_journey) {
      window.location.href = `/dashboard/journey/${id_journey}`
      console.log("El id_journey es: " + id_journey)
    },
    getTotalRouteJourney(number) {
      const lista = this.totalRoutesJourney.find(cat => cat.id_route_journey == number)
      return lista ? lista.total : 'total no disponible'
    },
    initializeChartData() {
      // Asignar los datos de series

      this.series = this.dataSeries;
      this.seriesTwo = this.dataSeriesTwo

      // Ajustar el valor máximo del eje Y
      if (this.series.length > 0) {
        const maxValue = Math.max(...this.series.flatMap(s => s.data));
        this.chartOptions.yaxis.max = Math.ceil(maxValue * 1.1); // 10% más que el valor máximo
      }
    },

    formatDate(date_str) {
      const date_route = new Date(date_str)
      const day_date_route = date_route.getDate().toString().padStart(2, '0')
      const month_date_route = (date_route.getMonth() + 1).toString().padStart(2, '0')
      const year_date_route = date_route.getFullYear()

      // Añadimos la hora, minutos y segundos
      const hours = date_route.getHours().toString().padStart(2, '0')
      const minutes = date_route.getMinutes().toString().padStart(2, '0')
      const seconds = date_route.getSeconds().toString().padStart(2, '0')

      return `${day_date_route}/${month_date_route}/${year_date_route} ${hours}:${minutes}:${seconds}`
    },
    formatDateOnly(date_str) {
      // Crear el objeto Date a partir de la cadena en formato YYYY-MM-DD
      const date_route = new Date(date_str + 'T00:00:00'); // Añadir 'T00:00:00' para evitar problemas de zona horaria
      return date_route.toLocaleDateString('es-ES'); // Formato DD/MM/YYYY
    },
    formatDateLong(date_str) {
      // Crear el objeto Date a partir de la cadena en formato YYYY-MM-DD
      const date_route = new Date(date_str + 'T00:00:00');

      // Opciones para el formato deseado
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      
      // Formatear la fecha
      return date_route.toLocaleDateString('es-ES', options);
    },
    getIconUrl(image) {
      // Adjust this path according to your project structure
      return `/img/${image}`
    },
    handleClickDetails(date) {
      window.location.href = `/dashboard/details/${date}`
      // this.$router.push(`dashboard/details/${date}`);
    },
    filterByDate(date) {
      this.$inertia.get('/', this.form);      
    },
    filterByDateRoute(date) {      
      // this.$inertia.get('/', this.form);
      //Usar hash en la URL
      this.$inertia.get('/?scroll=table', this.form, {
        preserveScroll: false,
        onSuccess: () => {
          window.location.hash = 'route-list';
        }
      });
    },
  },
  computed: {
    maxDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0'); // Meses de 0-11
      const day = String(today.getDate()).padStart(2, '0'); // Días de 1-31
      return `${year}-${month}-${day}`;
    },
  },
}
</script>